// API Configuration for Odds Predictor

// Production API URL (Cloudflare Worker)
export const API_BASE_URL = 'https://predict.kris.mt';

// Development API URL (local server)
export const DEV_API_URL = 'http://localhost:7001';

// Use production API in production, dev API in development
export const getApiUrl = () => {
  return process.env.NODE_ENV === 'production' ? API_BASE_URL : DEV_API_URL;
};

// Helper function to make authenticated API calls
export const apiCall = async (endpoint, options = {}) => {
  const token = localStorage.getItem('auth_token');
  const baseUrl = getApiUrl();
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
  };
  
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };
  
  const response = await fetch(`${baseUrl}${endpoint}`, mergedOptions);
  
  // Handle authentication errors
  if (response.status === 401) {
    localStorage.removeItem('auth_token');
    window.location.reload(); // Force re-login
  }
  
  return response;
};